import { pipe, ReadonlyArray } from "fp";
import * as Redux from "redux";

import * as Action from "~/Action";
import { actions } from "~/Action";
import { State } from "~/State";

export const reducer = (initial: State): Redux.Reducer<State, Action.Action> =>
  pipe(Reducers.forActions(), (reducers) => (state = initial, action) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    pipe(
      reducers[action.type] ?? (() => state),

      // TODO: Fix TypeScript language issue https://github.com/microsoft/TypeScript/issues/10530
      // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
      (reduce: any) => reduce(state, action)
    )
  );

namespace Reducers {
  /** Record of `action.type` to its `reduce` function */
  type Reducers = {
    /** For every `type` of action */
    [Type in Action.Action["type"]]: Extract<
      /** Extract `reduce` from the `actions` list where `type` matches */
      ReturnType<typeof actions>[number],
      { readonly TYPE: Type }
    >["reduce"];
  };

  export const forActions = (): Reducers =>
    pipe(
      actions(),
      ReadonlyArray.reduce({} as Reducers, (previous, { TYPE, reduce }) => ({
        ...previous,
        [TYPE]: reduce,
      }))
    );
}
